import { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { fetchData } from "../../../api/cancuiApi";


const zoneLabels = {
        'Zone1': 'Zone 1',
        'Zone2': 'Zone 2',
        'Zone3': 'Zone 3',
        'Zone4': 'Zone 4',
    };

function useGetCancuiList(sensorFilter) {

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        const requestBody = sensorFilter ? {
            "subject_filter": sensorFilter
        }: {}
        fetchData("CC_Susceptibility", requestBody)
            .then((res) => {
                if (res.objs && res.objs.length > 0) {
                    var results = res.objs
                    var formatted_results = results.map(row => {
                        let susceptibilityStatus = row?.susceptibilityStatus.split(",").map((item) => item.trim());
                        row.condensateRiskDetected = row?.condensateRiskDetected.split(",").map((item) => item.trim());
                        row.condensateRiskAssementStatus = []
                        susceptibilityStatus  = susceptibilityStatus?.map((ss, idx) => {
                            if(row?.condensateRiskDetected[idx] === 'True') {
                                if(ss !== ''){
                                    row.condensateRiskAssementStatus.push("Resolved")
                                    return ss
                                }else{
                                    row.condensateRiskAssementStatus.push("Pending")
                                    return "CONDENSATE RISK"
                                }
                            }
                            return ss;
                        }) 
                        row.susceptibilityStatus = susceptibilityStatus;
                        row.zones = row.zones.split(",").map(item => item.trim());
                        row.contributedIndex = row.zones.findIndex(zone => zone === row.id);
                        row.zones = row.zones.map(item => { 
                            const matchedLabel = Object.keys(zoneLabels).find(key => item.includes(key));
                            return matchedLabel ? zoneLabels[matchedLabel] : "";
                        });
                        row.consequence = row.consequence.split(",").map(item => item.trim());
                        row.criticality = row.criticality.split(",").map(item => item.trim());
                        row.probabilityFlag = row.probabilityFlag.split(",").map(item => item.trim());
                        const temperatureMethodMap = {"static": "Static", "dynamic": "Real-Time"};
                        const needsUserAttention = [];
                        row.temperatureMethod = row.temperatureMethod.split(",").map((item,idx) => 
                            {
                                if(item == 'static' && ['H', 'E'].includes(row.consequence[idx])){
                                    needsUserAttention.push(true);
                                }else{
                                    needsUserAttention.push(false);
                                }
                                return (temperatureMethodMap[item.trim()] || item.trim())
                            });
                        row.needsUserAttention = needsUserAttention;
                        row.condensateRiskHours = row.condensateRiskHours.split(",").map(item => parseInt(item.trim()) || 0);
                        row.condensateRiskAccepted = row.condensateRiskAccepted.split(",").map(item => item.trim());
                        row.coatingPerformanceAcceptable = row.coatingPerformanceAcceptable.split(",").map(item => item.trim());
                        return row;
                    });

                    setData(formatted_results);
                } else {
                    setData([]);
                }
            }).catch((error) => {
                console.error("Error fetching CAN-CUI data:", error);
                toast.error("Error fetching CAN-CUI data. Please try again later.");
                setIsError(true);
            }
            ).finally(() => {
                setIsLoading(false);
            }
            );


    }, [sensorFilter]);

    return {
        data,
        isLoading,
        isError,
    };
}
export default useGetCancuiList;